import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-100 mt-2 mb-0"
}

import { CallDataModule } from "@/store/modules/CallData";
import { TicketModule } from "@/store/modules/Ticket";
import { AppModule } from "@/store/modules/app";
import { IndexType } from "@/types/store";
import { computed } from "vue";

/* => props */

export default /*#__PURE__*/_defineComponent({
  props: {
    wrapperClass: null,
    callcenter: { type: Boolean, default: false },
    vertical: { type: Boolean, default: false },
    size: { default: "sm" }
  },
  setup(__props: any) {

const props = __props as { wrapperClass?: string, callcenter: boolean, vertical: boolean, size: "sm" | "md" | "lg" }



/*  => Computed */

// total buttons
const configButtons = computed(() =>
	AppModule.userConfig?.data.filter(field => field.type === "button")
);

// buttons for this user
const userButtons = computed(
	() =>
		configButtons.value?.reduce((acc, btn) => {
			const data = props.callcenter
				? (CallDataModule.user?.dynamicData?.[btn.name] as string)
				: (TicketModule.currentTicket?.client[0]?.dynamicData?.[
						btn.name
				  ] as string);
			console.log(btn, CallDataModule.user?.dynamicData);
			if (data)
				acc[btn.name] = { label: btn.label, value: data, icon: btn.icon };
			return acc;
		}, {} as IndexType<{ label: string; value: string; icon?: string }>) ?? {}
);

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_el_col = _resolveComponent("el-col")!

  return (Object.keys(_unref(userButtons)).length)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_component_el_col, {
          class: _normalizeClass(__props.wrapperClass)
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_unref(userButtons)), (btn, i) => {
              return (_openBlock(), _createBlock(_component_base_button, {
                tag: "a",
                size: __props.size,
                type: "warning",
                outline: "",
                key: i,
                href: btn.value,
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  (btn.icon)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass(btn.icon)
                      }, null, 2))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(btn.label), 1)
                ]),
                _: 2
              }, 1032, ["size", "href"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["class"]),
        (__props.vertical)
          ? (_openBlock(), _createElementBlock("hr", _hoisted_1))
          : _createCommentVNode("", true)
      ], 64))
    : _createCommentVNode("", true)
}
}

})